import * as React from 'react';

import { connect } from 'react-redux';

import ListProductionGroupsView from 'list-production-groups.view';
import { IPackageListingAppState } from '../../redux-state';
import { IPackageListingAppText } from '../../custom/classes/package-listing-text';
import { IPerformanceGroup, IPackage } from '../../custom/classes/production';

interface IListProductionGroupsExternalProps {
}

interface StateToProps {
    performanceGroups: IPerformanceGroup[];
    packageDetail: IPackage;
    text: IPackageListingAppText;
}

export type ListProductionGroupsProps = IListProductionGroupsExternalProps & StateToProps;

export class ListProductionGroupsBase extends React.Component<ListProductionGroupsProps, any> {
    render() {
        return (
            <ListProductionGroupsView {...this.props} />
        )
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IListProductionGroupsExternalProps): StateToProps {
    return {
        performanceGroups: state.packageListing.packageDetail.performanceGroupDetails,
        packageDetail: state.packageListing.packageDetail,   
        text: state.packageListingText
    }
}

export default connect<StateToProps>(mapStateToProps)(ListProductionGroupsBase);